import React from 'react';
import { useQuery } from 'react-query';
import { AB_Test } from 'services/ab-test';

const useABTest = () => {
    const { data } = useQuery('ab_test_init', AB_Test);
    const ABTest = data?.data || {}; // Accessing `data.data` safely
    const new_explore_test = ABTest?.new_explore_test === 'eligible' ? true : false; // Return 'default' if variant is missing
    return { new_explore_test }; // Properly returning data
};

export default useABTest;